<template>
    <!-- Canvas edit mode: one graph overlay at a time (see canvasModeStore). -->
    <div class="flex shrink-0 overflow-hidden rounded border border-gray-600" role="group" aria-label="Canvas mode">
        <button v-for="mode in canvas.modes" :key="mode.id" type="button"
            class="px-2 leading-5 disabled:cursor-not-allowed disabled:opacity-40"
            :class="mode.id === canvas.mode ? 'bg-emerald-700 text-white' : 'text-gray-300 enabled:hover:bg-gray-700'"
            :disabled="!mode.available"
            :aria-pressed="mode.id === canvas.mode"
            :title="mode.available ? mode.title : `${mode.title}: not available yet`"
            @click="canvas.setMode(mode.id)">{{ mode.label }}</button>
    </div>
</template>

<script setup>
import { useCanvasModeStore } from '../stores/canvasModeStore.js';

const canvas = useCanvasModeStore();
</script>
